module.exports = __webpack_public_path__ + "static/img/TLDLS.b454336a.png";